import riskDisclosureContent from "./content/risk-disclosure.json";

export const riskDisclosureMock = {
  name: "risk-disclosure",
  layoutType: 1,
  areasList: [
    {
      id: "risk-disclosure-1",
      name: "risk-disclosure-content",
      componentName: "Comp:RiskDisclosurePage",
      content: JSON.stringify(riskDisclosureContent),
    },
  ],
};
